<template>
     <form method="post" @submit.prevent="submitForm">
        <input type="hidden" name="PurchaseOrderId" v-model="PurchaseOrderId"/>
        <purchase-order-item-list ref="poObject" :items="items"></purchase-order-item-list>
        <input type="submit" class="btn btn-primary" value="submit"/>
    </form>
</template>
<script>
import PurchaseOrderItemList from './PurchaseOrderItemList.vue'
export default {
    name : 'purchase-order-form',
    props: ['items', 'PurchaseOrderId'],
    components: {
        'purchase-order-item-list' : PurchaseOrderItemList
    },
    data(){
        return {
            formData : {
                data : null
            },
            URLpurchaseOrderItemPost: 'purchase-order/items/store'
        }
    },
    methods:{
        submitForm: function(){
            this.formData.data = this.$refs.poObject.itemrows

            var unique = this.checkUniqueItems(this.$refs.poObject.itemrows, 'ItemId')
            this.$refs.poObject.itemrows = unique;

            // show message if duplicated items
            this.formData.data.map(v => v.ItemId).sort().sort((a, b) => {
                if (a === b) alert("We have removed duplicated items")
            })
            this.formData.data = this.$refs.poObject.itemrows
            this.formData['PurchaseOrderId'] =  this.PurchaseOrderId
            axios.post(this.URLpurchaseOrderItemPost, this.formData)
                .then(response => {
                    Swal.fire({
                            title: 'Submitted Successfully',
                            icon: 'success',
                        })
                    window.location.reload();
                }).
            catch(error => {
                this.errored = true
            })
            .finally(() => this.loading = false)
        },

        checkUniqueItems: function(arr, key){
            var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
            return uniqueItems;
        }
    }
}
</script>
